import { PropsWithChildren, memo } from 'react';
import styles from './styles.module.scss';
import { DateCardProps } from './props';

function DateCard({
  createdAt,
  children,
  isLoading,
}: PropsWithChildren<DateCardProps>) {
  return (
    <div className={styles.container}>
      {isLoading ? (
        <div className={styles.container__skeleton} />
      ) : (
        <span className={styles.container__label}>
          {new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          }).format(new Date(createdAt as string))}
        </span>
      )}
      {children}
    </div>
  );
}

export default memo(DateCard);
